export const TAGS = {
  SB_CONFIG: 'sb-config',
  SITEMAP: 'sitemap',
};
